var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "153 63 206 387",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.5 447.5c-6.07 0-11-4.93-11-11v-360c0-6.07 4.93-11 11-11h179c6.07 0 11 4.93 11 11v360c0 6.07-4.93 11-11 11h-179z",
    fill: "#ffffff",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5 68c4.69 0 8.5 3.81 8.5 8.5v360c0 4.69-3.81 8.5-8.5 8.5h-179c-4.69 0-8.5-3.81-8.5-8.5v-360c0-4.69 3.81-8.5 8.5-8.5h179m0-5h-179c-7.46 0-13.5 6.04-13.5 13.5v360c0 7.46 6.04 13.5 13.5 13.5h179c7.46 0 13.5-6.04 13.5-13.5v-360c0-7.46-6.04-13.5-13.5-13.5z",
    fill: "#ff0000",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "M203 95c0 9.389-7.611 17-17 17s-17-7.611-17-17 7.611-17 17-17 17 7.611 17 17z",
    "data-color": 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.74a47e1550ae9405a8f5278854e4e4ab.svg";
export { ForwardRef as ReactComponent };